<template>
  <button
    class="up-btn"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'upButton',
  inheritAttrs: false,
};
</script>
<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.up-btn {
  width: 100%;
  text-align: center;
  background: $color-base;
  border: 2px solid $color-primary;
  color: $color-primary;
}
</style>
